"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateManualBackupDialogModel = void 0;
const core_1 = require("@veeam/core");
class CreateManualBackupDialogModel extends core_1.Model {
    constructor(initialValue) {
        super(Object.assign(Object.assign({}, CreateManualBackupDialogModel.INITIAL_VALUE), initialValue));
    }
}
exports.CreateManualBackupDialogModel = CreateManualBackupDialogModel;
CreateManualBackupDialogModel.INITIAL_VALUE = {
    repositoryId: '',
    repositoryName: '',
    isIncludeSessionHistory: true,
};
//# sourceMappingURL=CreateManualBackupModel.js.map